import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { fetchAllPages } from './fetch-all-pages';

// Capa de datos de la revisión de evidencias del instructor (ENG-LAYER-01).
// Consolidado desde routes/instructor/evidence-review.data.ts.

export type EvidenceItem = {
  id: number;
  user_id: number;
  lesson_id: number | null;
  file_url: string;
  file_name: string;
  file_size: number;
  file_type: string;
  description: string | null;
  uploaded_at: string;
  status: 'pending' | 'approved' | 'rejected';
  reviewed_by: number | null;
  reviewed_at: string | null;
  review_notes: string | null;
  user: { id: number; first_name: string; last_name: string; email: string };
  reviewer: { id: number; first_name: string; last_name: string } | null;
};

type CourseListItem = { id: number; title: string; status: string };

type CourseDetail = {
  id: number;
  title: string;
  sections: Array<{
    id: number;
    title: string;
    lessons: Array<{ id: number; title: string; lesson_type: string }>;
  }>;
};

export function useCoursesList() {
  return useQuery({
    queryKey: ['instructor', 'courses-list'],
    queryFn: () => fetchAllPages<CourseListItem>('/courses'),
  });
}

export function useCourseDetail(courseId: number) {
  return useQuery({
    queryKey: ['courses', 'detail', courseId],
    queryFn: () => api.get<CourseDetail>(`/courses/${courseId}`),
    select: (res) => res.data,
    enabled: courseId > 0,
  });
}

export function useLessonEvidence(lessonId: number) {
  return useQuery({
    queryKey: ['instructor', 'evidence', lessonId],
    queryFn: () => fetchAllPages<EvidenceItem>(`/evidence/lesson/${lessonId}`),
    enabled: lessonId > 0,
  });
}
